import { FilterButtonGroup } from '@shared/components';
import { useNavigate, useParams } from '@user-management/router';

import type { AppOptions } from '../../types';

const APP_PERMISSION_ITEMS = [
  {
    label: 'Exam Management',
    value: 'exam-management',
  },
  {
    label: 'Exam Center',
    value: 'exam-center',
  },
  {
    label: 'User Management',
    value: 'user-management',
  },
  {
    label: 'Reports',
    value: 'reports',
  },
];

export default function AppPermissionButtonGroup() {
  const { appRoleId, app } = useParams('/roles-and-permissions/:appRoleId/permissions/:app');
  const navigate = useNavigate();

  const changeApp = (app: AppOptions) => {
    navigate('/roles-and-permissions/:appRoleId/permissions/:app', {
      params: {
        app,
        appRoleId,
      },
    });
  };

  return (
    <FilterButtonGroup
      items={APP_PERMISSION_ITEMS}
      value={app}
      onChange={(value) => changeApp(value as AppOptions)}
    />
  );
}
